import { render } from "./DeviceDetail.vue?vue&type=template&id=4e6a4425"
import script from "./DeviceDetail.vue?vue&type=script&lang=ts"
export * from "./DeviceDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script